var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgControlOver(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 46.926 44.654",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(-3597 -4112)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_429008568",
    transform: "translate(3597 4112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19268",
    "data-name": "Path 19268",
    d: "M3627.46,4151.13a.734.734,0,1,1,.667,1.307,21.153,21.153,0,0,1-4.724,1.749,21.36,21.36,0,1,1,15.583-15.01.734.734,0,0,1-1.414-.4,19.81,19.81,0,0,0,.552-2.661,19.879,19.879,0,1,0-15.063,16.645,19.822,19.822,0,0,0,4.395-1.627Z",
    transform: "translate(-3597 -4112)",
    fill: "#212832"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19269",
    "data-name": "Path 19269",
    d: "M7879.409,4149.072a.735.735,0,1,1,1.219.822,12.684,12.684,0,0,1-3.521,3.6,7.546,7.546,0,0,1-4.134,1.29c-3.392,0-6.429-2.46-8.59-6.435a34.744,34.744,0,0,1,0-29.91c2.164-3.975,5.2-6.435,8.59-6.435s6.429,2.46,8.591,6.435a31.952,31.952,0,0,1,3.383,14.955q0,.626-.026,1.378c-.018.485-.042.94-.07,1.367a.735.735,0,0,1-1.467-.1c.033-.459.058-.9.071-1.316q.02-.59.02-1.325a30.482,30.482,0,0,0-3.2-14.255c-1.9-3.5-4.489-5.665-7.3-5.665s-5.4,2.164-7.3,5.665a33.353,33.353,0,0,0,0,28.51c1.9,3.5,4.49,5.665,7.3,5.665a6.093,6.093,0,0,0,3.334-1.047,11.2,11.2,0,0,0,3.1-3.189Z",
    transform: "translate(-7851.583 -4112)",
    fill: "#212832"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19270",
    "data-name": "Path 19270",
    d: "M3598.735,13466.471a.735.735,0,0,1,0-1.471h41.308a.735.735,0,0,1,0,1.471Z",
    transform: "translate(-3597.998 -13444.345)",
    fill: "#212832"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19271",
    "data-name": "Path 19271",
    d: "M6117.516,7069.4a.735.735,0,0,1,.7-1.294,20.3,20.3,0,0,0,5.973,1.755,57.437,57.437,0,0,0,17.513-.009,20.012,20.012,0,0,0,5.969-1.773.735.735,0,0,1,.707,1.29,21.329,21.329,0,0,1-6.435,1.935,58.53,58.53,0,0,1-18,.009,21.67,21.67,0,0,1-6.426-1.912Z",
    transform: "translate(-6111.564 -7061.46)",
    fill: "#212832"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19272",
    "data-name": "Path 19272",
    d: "M6117.412,18712.9a.735.735,0,0,1-.7-1.295,21.708,21.708,0,0,1,6.426-1.912,55.552,55.552,0,0,1,8.973-.691c.793,0,1.619.018,2.464.051s1.654.082,2.412.141a.736.736,0,0,1-.115,1.467c-.795-.064-1.581-.111-2.354-.141-.75-.029-1.555-.045-2.407-.045a53.916,53.916,0,0,0-8.729.668,20.325,20.325,0,0,0-5.974,1.756Z",
    transform: "translate(-6110.765 -18676.764)",
    fill: "#212832"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19273",
    "data-name": "Path 19273",
    d: "M16221.994,15621.994a6.809,6.809,0,1,1-1.994,4.814A6.79,6.79,0,0,1,16221.994,15621.994Zm4.814-.521a5.34,5.34,0,1,0,3.771,1.564A5.312,5.312,0,0,0,16226.809,15621.473Z",
    transform: "translate(-16192.124 -15594.586)",
    fill: "#212832"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19274",
    "data-name": "Path 19274",
    d: "M20870.717,20357.756a.736.736,0,0,1,1.041-1.041l2.145,2.148a.735.735,0,0,1-1.039,1.039Z",
    transform: "translate(-20832.355 -20320.627)",
    fill: "#212832"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19275",
    "data-name": "Path 19275",
    d: "M21761.648,21248.645a2.211,2.211,0,0,1,3.121,0l2.4,2.4a2.216,2.216,0,0,1,.012,3.113.194.194,0,0,0-.021.02,2.216,2.216,0,0,1-3.115-.01l-2.4-2.4a2.214,2.214,0,0,1,0-3.123Zm1.561.826a.736.736,0,0,0-.521,1.256l2.4,2.4a.74.74,0,0,0,1.043,0,.738.738,0,0,0,0-1.041l-2.4-2.4A.738.738,0,0,0,21763.209,21249.471Z",
    transform: "translate(-21720.887 -21210.156)",
    fill: "#212832"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlOver);
export default __webpack_public_path__ + "static/media/ControlOver.7d37140949bba44a68440357d1db1908.svg";
export { ForwardRef as ReactComponent };